import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "../styles/projects.css";

const Projects = () => {
  return (
    <div className="projects">
      <div>
        <Table>
          <caption>RELEVANT PROJECTS COMPLETED</caption>
          <Thead>
            <Tr>
              <Th style={{ textAlign: "center" }}>Starting Year</Th>
              <Th style={{ textAlign: "center" }}>Ending Year</Th>
              <Th style={{ textAlign: "center" }}>Duration</Th>

              <th style={{ textAlign: "center" }}>Contract Identification</th>
              <Th style={{ textAlign: "center" }}>
                Role of Bidder (Main/Sub Contractor)
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {/* ── NEW PROJECTS ── */}
            <Tr>
              <Td>21st May 2025</Td>
              <Td>Ongoing</Td>
              <Td>-</Td>
              <Td>
                <strong>Contract Name: </strong>Rehabilitation of 12.1 Km of
                Community Access Roads (CARs) in Kobuin Sub-County, Ngora
                District under NOSP Batch A - Contract No:
                MoLG-NOSP/Ngora/WORKS/2023-2024/00032/A69
                <br />
                <strong>Description of the works:</strong> Rehabilitation of
                community access roads including earthworks, drainage works,
                gravelling and road furniture installation
                <br />
                <strong>Amount of the Contract:</strong> UGX 1,056,449,979
                <br />
                <strong>Name of the Employer:</strong> Government of Uganda
                Represented by Ngora District Local Government, P.O. Box 31
                Ngora, Uganda (Funded by IFAD &amp; OPEC Fund under the National
                Oilseeds Project - NOSP)
              </Td>
              <Td>Main Contractor</Td>
            </Tr>
            <Tr>
              <Td>2025</Td>
              <Td>Ongoing</Td>
              <Td>-</Td>
              <Td>
                <strong>Contract Name: </strong>Rehabilitation of Access Roads
                in Ngora District under NOSP
                <br />
                <strong>Description of the works:</strong> Rehabilitation of
                access roads including earthworks, drainage works and gravelling
                under the National Oilseeds Project (NOSP)
                <br />
                <strong>Name of the Employer:</strong> Ngora District Local
                Government / Ministry of Local Government (National Oilseeds
                Project - NOSP)
              </Td>
              <Td>Main Contractor</Td>
            </Tr>
            <Tr>
              <Td>2024</Td>
              <Td>Ongoing</Td>
              <Td>-</Td>
              <Td>
                <strong>Contract Name: </strong>Emergency Road Repairs along
                Kabale - Kisoro Road
                <br />
                <strong>Description of the works:</strong> Emergency repair
                works on the Kabale-Kisoro Road including earthworks, drainage
                restoration, gravelling and slope stabilisation
                <br />
                <strong>Name of the Employer:</strong> Uganda National Roads
                Authority (UNRA) - Kabale Station
              </Td>
              <Td>Main Contractor</Td>
            </Tr>
            <Tr>
              <Td>2024</Td>
              <Td>Ongoing</Td>
              <Td>-</Td>
              <Td>
                <strong>Contract Name: </strong>Construction of Kajamaka Earth
                Dam 1 in Kumi District
                <br />
                <strong>Description of the works:</strong> Civil works for the
                construction of Kajamaka Earth Dam including excavation,
                compaction, embankment works and spillway construction
                <br />
                <strong>Name of the Employer:</strong> Government of Uganda
                Represented by Ministry of Local Government
              </Td>
              <Td>Main Contractor</Td>
            </Tr>
            <Tr>
              <Td>2024</Td>
              <Td>Ongoing</Td>
              <Td>-</Td>
              <Td>
                <strong>Contract Name: </strong>Construction of Animal Disease
                Control Centre in Soroti 1
                <br />
                <strong>Description of the works:</strong> Design, construction
                and installation of administrative facilities, livestock
                handling infrastructure, perimeter fencing, access roads and
                water supply systems for the animal disease control centre
                <br />
                <strong>Name of the Employer:</strong> Ministry of Agriculture,
                Animal Industry and Fisheries
              </Td>
              <Td>Main Contractor</Td>
            </Tr>
            <Tr>
              <Td>2024</Td>
              <Td>Ongoing</Td>
              <Td>-</Td>
              <Td>
                <strong>Contract Name: </strong>Soroti — Civil Works &amp;
                Infrastructure
                <br />
                <strong>Description of the works:</strong> Civil and
                infrastructure works in Soroti District
                <br />
                <strong>Name of the Employer:</strong> Government of Uganda
              </Td>
              <Td>Main Contractor</Td>
            </Tr>

            {/* ── EXISTING PROJECTS ── */}
            <Tr>
              <Td> 4th December 2024</Td>
              <Td> 4th November 2025</Td>
              <Td> 11 months</Td>
              <Td>
                <strong> Contract Name: </strong>Construction of Zonal Animal
                diseases control centres under AVCP-1 project - lot 1: soroti
                zonal animal diseases control centre
                <br />
                <strong> Description of the works:</strong>
                Design, construction, and installation of administrative
                facilities, livestock handling infrastructure, perimeter
                fencing, access roads, and water supply systems.
                <br />
                <strong> Amount of the Contract:</strong>UGX 2,732,535,530
                <br />
                <strong> Name of the Employer:</strong> Ministry of Agriculture,
                Animal Industry and Fisheries
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>29th jan 2025</Td>
              <Td>28th September 2025</Td>
              <Td> 8 months</Td>
              <Td>
                <strong> Contract Name: </strong>Rehabilitation of (11.14) Km of
                Community Access Roads in Ongino Sub County Kumi District Under
                Batch A
                <br />
                <strong> Description of the works:</strong>
                Site preparatory works ,Setting out and site clearance ,Earth
                works 11.14km,Drainage works ,Gravelling and completion works
                and Preliminaries and general items <br />
                <strong> Amount of the Contract:</strong> UGX 1,007,426,151
                <br />
                <strong> Name of the Employer:</strong> Kumi District Local
                Government
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>4th September 2024 </Td>
              <Td> 4th July 2025 </Td>
              <Td> 10 months</Td>
              <Td>
                <strong> Contract Name: </strong> Construction of kajamaka earth
                dam in kumi district under the local economic growth
                support(legs) project
                <br />
                <strong> Description of the works:</strong>
                Design, excavation, earthworks, and infrastructure development
                <br />
                <strong> Amount of the Contract:</strong> UGX 3,875,445,343.00
                <br />
                <strong> Name of the Employer:</strong> Government of Uganda
                represented by Ministry of Local Government
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>20th July 2023</Td>
              <Td>24th September 2024</Td>
              <Td>1 year</Td>
              <Td>
                <strong> Contract Name: </strong>Rehabilitation of
                habikyenzi-Keitankombe-Nyakahita-Mushunga-Minizi-rweturwe-Kangorongoro-hakyishenyi;with
                Accesses to Keitankombe COU, Nyakahita Catholic Church and
                hakishenyi P/S (10.2KM) and Kyocezo-Butambi Road (2.7Km) in
                Rubanda District; Total Length =12.9km Contract No:
                MoWT/WRKS/CRIP/22-23/100
                <br />
                <strong> Description of the works:</strong>
                Earthworks, drainage works, gravelling <br />
                <strong> Amount of the Contract:</strong> UGX 1,966,020,420
                <br />
                <strong> Name of the Employer:</strong> Ministry of Works &
                Transport Address: P.O. Box 7174, Kampala
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td> 28th September 2023</Td>
              <Td>24th April 2024</Td>
              <Td>1 year</Td>
              <Td>
                <strong> Contract Name: </strong>Emergency Repair Works At Km
                16+000- 16+200 Along Kabale- Kisoro Road Contract No:
                UNRA/WORKS/2022-2023/00106
                <br />
                <strong> Description of the works:</strong>
                Earthworks, drainage works, gravelling <br />
                <strong> Amount of the Contract:</strong> UGX 3,743,082,622
                <br />
                <strong> Name of the Employer:</strong> Uganda National Roads
                Authority - Kabale Station Address: P.O. Box 248434 Kampala
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>1st June 2022</Td>
              <Td>25th July 2023</Td>
              <Td>1 year</Td>
              <Td>
                <strong> Contract Name: </strong>Low Cost Sealing of selected
                low volume roads ;Lot 4; Kanyeganegye - Nyakaisa Road (5.0 Km)
                in Rukiga District; Contract No: MOWT/WRKS/21-22/00275/Lot 4/01
                <br />
                <strong> Description of the works:</strong>
                Earthworks, drainage works, gravelling <br />
                <strong> Amount of the Contract:</strong> UGX 4, 899,268,285
                <br />
                <strong> Name of the Employer:</strong> Ministry of Works &
                Transport Address: P.O. Box 7174, Kampala
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>11th October 2021</Td>
              <Td>23rd May 2022</Td>
              <Td>8 months</Td>
              <Td>
                <strong> Contract Name: </strong>Construction & Rehabilitation
                of Kagongi-Buwama Community Access Road (33km) Contract Ref:
                NAK(LEGS)WRKS/20-21/00001-10/7 <br />
                <strong> Description of the works:</strong>
                Drainage ,Earthworks, Pavement &Ancillary Roadworks <br />
                <strong> Amount of the Contract:</strong> UGX 2 ,020,754,400
                <br />
                <strong> Name of the Employer:</strong> Ministry of Local
                Government P.O. Box 7037,Kampala
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>9th May 2019</Td>
              <Td>8th January 2022</Td>
              <Td>3 years </Td>
              <Td>
                <strong> Contract Name: </strong>Design And Build Of Masindi
                Kisanja-Park Junction And Tangi Junction- Paraa-Bulisa Roads
                Upgrading Project(159km)Package 1 <br />
                <strong> Description of the works:</strong>Drainage ,Earthworks,
                Pavement &Ancillary Roadworks <br />
                <strong> Amount of the Contract:</strong> UGX 12,983,905,739
                <br />
                <strong> Name of the Employer:</strong> UNRA
                <br />
                <strong>Email:dnf@cfhec.com </strong>
              </Td>
              <Td> Sub-Contractor </Td>
            </Tr>
            <Tr>
              <Td>27th July 2020 </Td>
              <Td>20th August 2021</Td>
              <Td>1 year & 1 month </Td>
              <Td>
                <strong> Contract Name: </strong>Periodic Maintenance of
                selected unpaved roads under framework contracts for 23 UNRA
                Stations. Lot 06 Kabale station <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling <br />
                <strong> Amount of the Contract:</strong> UGX 7,748,712,490
                <br />
                <strong> Name of the Employer:</strong> Uganda National Roads
                Authority - Kabale Station Address: P.O.Box 248434 Kampala
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>2020 </Td>
              <Td>2021</Td>
              <Td>1 year </Td>
              <Td>
                <strong> Contract Name: </strong>Mechanized Maintenance of
                selected unpaved roads under framework contracts for 3 years ;
                totaling to 319km <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling <br />
                <strong> Amount of the Contract:</strong> UGX 5,198,494,484
                <br />
                <strong> Name of the Employer:</strong>Uganda National Roads
                Authority - Kabale Station Address: P.O.Box 248434 Kampala
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>2020 </Td>
              <Td>2021</Td>
              <Td>1 year </Td>
              <Td>
                <strong> Contract Name: </strong> Mechanized Maintenance of
                selected unpaved roads under framework contracts for 3 years lot
                11 ; totaling to 319km <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling <br />
                <strong> Amount of the Contract:</strong> UGX 3,698,507,394
                <br />
                <strong> Name of the Employer:</strong>Uganda National Roads
                Authority - Kabale Station Address: P.O.Box 248434 Kampala
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td> 11th April 2019</Td>
              <Td>11th April 2020</Td>
              <Td>12 months </Td>
              <Td>
                <strong> Contract Name: </strong>Rehabilitation of Selected
                Gravel Roads in Bulisa District Contract no:
                MLHUD/WORKS/2017-18/00485 <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling <br />
                <strong> Amount of the Contract:</strong> UGX 6,359,779,348
                <br />
                <strong> Name of the Employer:</strong>Ministry of Works and
                Transport
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td> 2018</Td>
              <Td>2020</Td>
              <Td>3 years </Td>
              <Td>
                <strong> Contract Name: </strong>Mechanized Maintenance Of
                Selected Un paved National Roads Under Framework Contracts For 3
                Years Totaling to (319km ) <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling <br />
                <strong> Amount of the Contract:</strong> UGX 20,877,603,109
                <br />
                <strong> Name of the Employer:</strong>Uganda National Roads
                Authority - Kabale Station Address: P.O.Box 248434 Kampala
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td> 2018 </Td>
              <Td>May 2019 </Td>
              <Td>1 year </Td>
              <Td>
                <strong> Contract Name: </strong>Renovation works at Former
                Faculty of Art Building -Makerere University <br />
                <strong> Description of the works:</strong>civil and Building
                works. <br />
                <strong> Amount of the Contract:</strong> UGX 246,000,000
                <br />
                <strong> Name of the Employer:</strong>Makerere University
                Address: P.O. Box 7062, Kampala
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td> 7th December 2018</Td>
              <Td>7th December 2018</Td>
              <Td>1 year & 9 Months </Td>
              <Td>
                <strong> Contract Name: </strong>Renovation of City Hall Wing A
                and Wing B Roof <br />
                <strong> Description of the works:</strong>civil and Building
                works. <br />
                <strong> Amount of the Contract:</strong> UGX 414,889,501
                <br />
                <strong> Name of the Employer:</strong>Kampala Capital City
                Authority (KCCA) Address: P.O. Box 7010 , Kampala
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td> 26th April 2017 </Td>
              <Td>July 2018</Td>
              <Td>1 year & 5 months </Td>
              <Td>
                <strong> Contract Name: </strong>construction of Climate
                Resilient Institutional &Public Sanitation Facilities <br />
                <strong> Description of the works:</strong>Civil works and
                building works <br />
                <strong> Amount of the Contract:</strong> UGX 3,555,356,753
                <br />
                <strong> Name of the Employer:</strong>Ministry of Water
                &Environment
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>10th may 2017 </Td>
              <Td>23rd December 2017 </Td>
              <Td>8 months </Td>
              <Td>
                <strong> Contract Name: </strong>Rehabilitation of 7.5km of
                community Access roads in Nyakyera Sub-county ,Ntungamo district
                Local government <br />
                <strong> Description of the works:</strong>: Earthworks,
                drainage works, gravelling And bridge works
                <br />
                <strong> Amount of the Contract:</strong> UGX 676,727,749
                <br />
                <strong> Name of the Employer:</strong>Ntungamo District Local
                Government P.O Box Ntungamo
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>23rd November 2017 </Td>
              <Td>23rd may 2018 </Td>
              <Td> 6 months </Td>
              <Td>
                <strong> Contract Name: </strong>Remodelling /construction of
                classroom block at Makerere College <br />
                <strong> Description of the works:</strong>Building works of
                nature
                <br />
                <strong> Amount of the Contract:</strong> UGX 527,894,877
                <br />
                <strong> Name of the Employer:</strong>Kampala Capital City
                Authority Address: P.O Box 7010, Kampala, Uganda
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>2015 </Td>
              <Td>2016 </Td>
              <Td>1 year </Td>
              <Td>
                <strong> Contract Name: </strong>Periodic Maintenance of 44
                selected National Roads (28 Lots ); Lot 27 ; Kyankanda -
                Bitsya-Ruhoko & Access Roads (56km)
                <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling
                <br />
                <strong> Amount of the Contract:</strong> UGX 3,132,593,200
                <br />
                <strong> Name of the Employer:</strong>Uganda National Roads
                Authority (UNRA)-Mbarara- Station <br />
                Address: P.O. Box P.O.Box 4 Mbarara
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>2015 </Td>
              <Td>2016 </Td>
              <Td>1 year </Td>
              <Td>
                <strong> Contract Name: </strong>Rehabilitation of Nyeihanga
                -yeimpitsi -Rwakaberengye Kikagate(22.7km),Karera
                -TI&Karera-Kisoroza Roads (2.7km)
                <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling And bridge works.
                <br />
                <strong> Amount of the Contract:</strong> UGX 32,059,984,817
                <br />
                <strong> Name of the Employer:</strong>Kabwohe District Local
                Government <br />
                Address: P.O.Box160 Kabwohe
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>June 2014 </Td>
              <Td>August 2015 </Td>
              <Td> 1 year &3 months </Td>
              <Td>
                <strong> Contract Name: </strong>periodic mantainance of 12
                selected National Roads (11 Lots) ; lot 10 Nyakabirizi -Burere
                Nsika road (45km)
                <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling And bridge works.
                <br />
                <strong> Amount of the Contract:</strong> UGX 1,482,940,000
                <br />
                <strong> Name of the Employer:</strong>Uganda National Roads
                Authority (UNRA)
                <br />
                Address: (UNRA Kampala)
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>February 2014 </Td>
              <Td>2015 </Td>
              <Td> 1 year </Td>
              <Td>
                <strong> Contract Name: </strong>periodic mantainance of 12
                selected National Roads (11 Lots) ; lot 10 Nyakabirizi -Burere
                Nsika road (45km)
                <br />
                <strong> Description of the works:</strong>Rehabilitation of
                15.6km of community Access roads in kagongi sub-county ,Mbarara
                district local Government
                <br />
                <strong> Amount of the Contract:</strong> UGX 1,093,482,075
                <br />
                <strong> Name of the Employer:</strong>Mbarara District Local
                Government
                <br />
                Address: P.O Box 01, Mbarara
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>5th Nov 2013 </Td>
              <Td>29th May 2015</Td>
              <Td> 2 years & 6 months </Td>
              <Td>
                <strong> Contract Name: </strong>Rehabilitation of 15.6km of
                community Access roads -Kamurinda -kakindoo-Muzia -kalyango Road
                in Kyangyenyi Sub-county sheema District Local Government
                <br />
                <strong> Description of the works:</strong>Rehabilitation of
                15.6km of community Access roads in kagongi sub-county ,Mbarara
                district local Government
                <br />
                <strong> Amount of the Contract:</strong> UGX 2,145,177,775
                <br />
                <strong> Name of the Employer:</strong>sheema District Local
                Government
                <br />
                Address: P.O.Box 160 Kabwohe
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>Feb 2012 </Td>
              <Td>Feb 2013 </Td>
              <Td> 1 year </Td>
              <Td>
                <strong> Contract Name: </strong>Construction of 1 stored ,3
                Classroom block with library ,2 storied 6 Classroom block with
                multi-purpose rooms ,4 fivr stance VIP Latrines , I
                administrative block at Asinge secondary school in Tororo
                District
                <br />
                <strong> Description of the works:</strong>general construction
                works ,Renovations and refurbishments ,civil works and supplies
                <br />
                <strong> Amount of the Contract:</strong> UGX 1,276,057,474
                <br />
                <strong> Name of the Employer:</strong>Asinge secondary
                /ministry of Education and sports
                <br />
                Address: P.O Box 678,Tororo
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>22nd November 2013 </Td>
              <Td>7th February 2015</Td>
              <Td>2 years & 3 months </Td>
              <Td>
                <strong> Contract Name: </strong>construction of double storeyed
                Nine classroom block at Kamwokya Primary school
                <br />
                <strong> Description of the works:</strong>General civil works,
                electrical installation, mechanical installation and furniture
                supplies
                <br />
                <strong> Amount of the Contract:</strong> UGX 1,125,369,066
                <br />
                <strong> Name of the Employer:</strong>Kampala Capital city
                Authority
                <br />
                Address: P.O Box Kampala, Uganda
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>February 2014 </Td>
              <Td>2015</Td>
              <Td>1 year </Td>
              <Td>
                <strong> Contract Name: </strong>periodic maintenance of
                selected National Roads (11 Lots); lot 10 Nyakabirizi-Burere
                -Nsika Road (45km)
                <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling and bridge works.
                <br />
                <strong> Amount of the Contract:</strong> UGX 1,482,940,000
                <br />
                <strong> Name of the Employer:</strong>UNRA
                <br />
                Address: P.O.BOX 28487, KAMPALA
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>February 2014 </Td>
              <Td>2015</Td>
              <Td>1 year </Td>
              <Td>
                <strong> Contract Name: </strong>rehabilitation of 15.6km of
                community access roads in kagongi sub-county ,Mbarara District
                Local Government
                <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling and bridge works.
                <br />
                <strong> Amount of the Contract:</strong> UGX 1,093,482,075
                <br />
                <strong> Name of the Employer:</strong>Mbarara District Local
                Government
                <br />
                Address: P.O.BOX 01,Mbarara
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td>11th October 2021 </Td>
              <Td>23rd May 2022</Td>
              <Td>8 months </Td>
              <Td>
                <strong> Contract Name: </strong>construction &Rehabilitation of
                Kagongi-BuwamaCommunity Access Road (33km) Contract Ref:
                NAK(LEGS)WRKS/20-21/00001-10/7
                <br />
                <strong> Description of the works:</strong>Drainage ,Earthworks,
                Pavement &Ancillary Roadworks
                <br />
                <strong> Amount of the Contract:</strong> UGX 2,020,754,400
                <br />
                <strong> Name of the Employer:</strong>China Communications
              </Td>
              <Td> Main Contractor </Td>
            </Tr>
            <Tr>
              <Td> 9th May 2019 </Td>
              <Td>8th January 2022</Td>
              <Td>3 years </Td>
              <Td>
                <strong> Contract Name: </strong>Design And Build Of Masindi
                Kisanja-Park Junction And Tangi Junction - Paraa-Bulisa Roads
                Upgrading Project(159km)Package 1
                <br />
                <strong> Description of the works:</strong>Drainage ,Earthworks,
                Pavement &Ancillary Roadworks
                <br />
                <strong> Amount of the Contract:</strong> UGX 12,983,905,739
                <br />
                <strong> Name of the Employer:</strong>China Communications
                Construction Company <br />
                <strong>Email:dnf@cfhec.com </strong>
              </Td>
              <Td> Sub-Contractor </Td>
            </Tr>
            <Tr>
              <Td>27th July 2020 </Td>
              <Td> 20th August 2021</Td>
              <Td>1 year & 1 month </Td>
              <Td>
                <strong> Contract Name: </strong>Periodic Maintenance of
                selected unpaved roads under framework contracts for 23 UNRA
                Stations. Lot 06 Kabale station
                <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling
                <br />
                <strong> Amount of the Contract:</strong>UGX 7,748,712,490
                <br />
                <strong> Name of the Employer:</strong>Uganda National Roads
                Authority - Kabale Station <br />
                Address: P.O.Box 248434 Kampala
              </Td>
              <Td>Main Contractor</Td>
            </Tr>
            <Tr>
              <Td>2020 </Td>
              <Td>2021</Td>
              <Td>1 year</Td>
              <Td>
                <strong> Contract Name: </strong>Mechanized Maintenance of
                selected unpaved roads under framework contracts for 3 years ;
                totaling to 319km
                <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling
                <br />
                <strong> Amount of the Contract:</strong>UGX 5,198,494,484
                <br />
                <strong> Name of the Employer:</strong>Uganda National Roads
                Authority - Kabale Station <br />
                Address: P.O.Box 248434 Kampala
              </Td>
              <Td>Main Contractor</Td>
            </Tr>
            <Tr>
              <Td>2020 </Td>
              <Td>2021</Td>
              <Td>1 year</Td>
              <Td>
                <strong> Contract Name: </strong>Mechanized Maintenance of
                selected unpaved roads under framework contracts for 3 years lot
                11 ; totaling to 319km <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling
                <br />
                <strong> Amount of the Contract:</strong>UGX 3,698,507,394
                <br />
                <strong> Name of the Employer:</strong>Uganda National Roads
                Authority - Kabale Station <br />
                Address: P.O.Box 248434 Kampala
              </Td>
              <Td>Main Contractor</Td>
            </Tr>
            <Tr>
              <Td> 11th April 2019 </Td>
              <Td>11th April 2020</Td>
              <Td>12 months </Td>
              <Td>
                <strong> Contract Name: </strong>Rehabilitation of Selected
                Gravel Roads in Bulisa District Contract no:
                MLHUD/WORKS/2017-18/00485
                <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling
                <br />
                <strong> Amount of the Contract:</strong>UGX 6,359,779,348
                <br />
                <strong> Name of the Employer:</strong>Ministry of Works &
                Transport
              </Td>
              <Td>Main Contractor</Td>
            </Tr>
            <Tr>
              <Td>2018 </Td>
              <Td>2020</Td>
              <Td>3 years</Td>
              <Td>
                <strong> Contract Name: </strong>Mechanized Maintenance Of
                Selected Un paved National Roads Under Framework Contracts For 3
                Years Totaling to (319km )
                <br />
                <strong> Description of the works:</strong>Earthworks, drainage
                works, gravelling
                <br />
                <strong> Amount of the Contract:</strong>UGX 20,877,603,109
                <br />
                <strong> Name of the Employer:</strong>: Uganda National Roads
                Authority - Kabale Station <br />
                Address: P.O.Box 248434 Kampala
              </Td>
              <Td>Main Contractor</Td>
            </Tr>
          </Tbody>
        </Table>
      </div>
    </div>
  );
};

export default Projects;
